import SeoJsonLd from '../../components/feature/SeoJsonLd';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
const logoUrl = 'https://static.readdy.ai/image/7e3352e848b93c3eb9a2ea481cb871cb/513bb4a137418228aa54dc71c4f368f7.png';

const jsonLdSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '스튜디오 디졸브',
    alternateName: 'Studio Dissolve',
    url: siteUrl,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '스튜디오 디졸브',
    alternateName: 'Studio Dissolve',
    url: siteUrl,
    logo: logoUrl,
    email: 'hello@dslv.kr',
    description:
      '스튜디오 디졸브는 발상의 전환을 만드는 콘텐츠 제작사입니다. 방송, OTT, 디지털 콘텐츠 기획부터 완성까지 제작합니다.',
    knowsAbout: [
      '콘텐츠 제작',
      '포맷 개발',
      '유통 전략',
      '브랜드 통합',
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: '서비스',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Content Production',
            description: '방송, OTT, 디지털까지 – 기획부터 완성까지 제작합니다',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Format Development',
            description: '아이디어를 확장 가능한 콘텐츠 포맷과 IP로 설계합니다',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Distribution Strategy',
            description: '콘텐츠가 확산되는 구조와 플랫폼 전략을 만듭니다',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Brand Integration',
            description: '브랜드를 콘텐츠 안에 자연스럽게 통합합니다',
          },
        },
      ],
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@dslv.kr',
      contactType: 'customer service',
      availableLanguage: ['Korean'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/#webpage`,
    url: siteUrl,
    name: '스튜디오 디졸브 | 콘텐츠 프로덕션 스튜디오',
    description:
      '스튜디오 디졸브는 발상의 전환을 만드는 콘텐츠 제작사입니다. 방송, OTT, 디지털 콘텐츠 기획부터 완성까지. KBSN, TVN 등 다양한 플랫폼을 위한 프로덕션 스튜디오.',
    inLanguage: 'ko-KR',
    isPartOf: {
      '@type': 'WebSite',
      url: siteUrl,
    },
  },
];

export default function Home() {
  return (
    <main className="w-full bg-white">
      <SeoJsonLd schemas={jsonLdSchemas} />
      <Navbar />
      <section>
        <Hero />
      </section>
      <section>
        <About />
      </section>
      <section>
        <Services />
      </section>
      <section>
        <Clients />
      </section>
      <section>
        <Contact />
      </section>
      <Footer />
    </main>
  );
}
